if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true'){
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        return;
      } 
      
      let errorMessages = [];

      const requiredFields = [
          
          { name: 'Have you changed your residential address within the previous 90 days?', selector: '[name="properties[Have you changed your residential address within the previous 90 days?]"]', errorMessage: "'Have you changed your residential address within the previous 90 days?' option is required" },
          { name: 'First Name', selector: '[name="properties[First Name]"]', errorMessage: "First Name option is required" },
          { name: 'Last Name', selector: '[name="properties[Last Name]"]', errorMessage: "Last Name option is required" },
          { name: 'State (US)', selector: '[name="properties[State (US)]"]', errorMessage: "State option is required" },
          { name: 'Street Address', selector: '[name="properties[Street Address]"]', errorMessage: "Street Address option is required" },
          { name: 'Town/City', selector: '[name="properties[Town/City]"]', errorMessage: "Town / City option is required" },
          { name: 'ZIP Code', selector: '[name="properties[ZIP Code]"]', errorMessage: "ZIP Code option is required" },
          { name: 'Vehicle Identification Number', selector: '[name="properties[Vehicle Identification Number]"]', errorMessage: "Vehicle Identification Number option is required" },
          { name: 'Vehicle Color', selector: '[name="properties[Vehicle Color]"]', errorMessage: "Vehicle Color option is required" },
          { name: 'Phone Number', selector: '[name="properties[Phone Number]"]', errorMessage: "Phone Number option is required" },
          { name: 'Email Address', selector: '[name="properties[Email Address]"]', errorMessage: "Email Address option is required" },
          { name: 'Driver Licenses', selector: '[name="properties[Driver Licenses]"]', errorMessage: "Driver Licenses option is required" },
          { name: 'Another Driver Licenses', selector: '[name="properties[Another Driver Licenses]"]', errorMessage: "Another Driver Licenses option is required" },
          { name: 'Will the tag be registered under a company name or a personal name?', selector: '[name="properties[Will the tag be registered under a company name or a personal name?]"]', errorMessage: "'Will the tag be registered under a company name or a personal name?' option is required" },
          { name: 'Is your vehicle covered by insurance?', selector: '[name="properties[Is your vehicle covered by insurance?]"]', errorMessage: "'Is your vehicle covered by insurance?' option is required" },
          { name: 'Company certificate or tax identification document', selector: '[name="properties[Company certificate or tax identification document]"]', errorMessage: "'Company certificate or tax identification document' option is required" },
          { name: 'Vehicle Auto insurance', selector: '[name="properties[Vehicle Auto insurance]"]', errorMessage: "'Vehicle Auto insurance' option is required" },
          { name: 'Proof of Vehicle Ownership', selector: '[name="properties[Proof of Vehicle Ownership]"]', errorMessage: "'Proof of Vehicle Ownership' option is required" }
      ];
      
            // Existing code for requiredFields
      
      for (const field of requiredFields) {
          const element = document.querySelector(field.selector);
          if (element !== null && element.value.trim() === "") {
              element.classList.add('input-error');
              errorMessages.push(field.errorMessage);
          } else {
              // element.classList.remove('input-error');
          }
      }
      
      if (errorMessages.length > 0) {
          this.handleErrorMessage(errorMessages.join('<br>'));
          return;
      }
      
      // No empty fields, proceed with the form submission or other actions


   
      this.handleErrorMessage();
      
      this.form.submit();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        document.querySelector('.loader__submit').classList.remove('hidden');
        document.querySelector('.uploading_msg').classList.remove('hidden');
        this.submitButton.textContent = 'Uploading and Adding to cart...';
      return;
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        // Replace <br> tags with &lt;br&gt;
        // errorMessage = errorMessage.replace(/<br>/g, '&lt;br&gt;');
        this.errorMessage.innerHTML = errorMessage;
      }
    }
  });
}
